export default "__VITE_ASSET__BhDVr4jb__"